export const CONNECT_WS = 'CONNECT_WS'
export const CLOSE_WS = 'CLOSE_WS'
export const AUTH = 'AUTH'
